export { default } from './Home24HeroF1';
